import { Card } from 'entities/card/model/types';
import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';

const activateCardApi = api.injectEndpoints({
    endpoints: build => ({
        send: build.mutation<ApiResponse<Card>, ({
            accountId: number,
            cardId: number,
            cvv: string
        })>({
            query: ({ accountId, cardId, cvv }) => ({
                url: `private/river/${accountId}/card/physical/${cardId}/activate-by-cvv`,
                method: 'POST',
                params: { cvv }
            })
        }),
    })
});
export const { useSendMutation } = activateCardApi;

export default activateCardApi;
